export enum AssessmentTopics {
  ListeningAndSpeaking = 'Listening & Speaking',
  ReadingAndUnderstanding = 'Reading & Understanding',
  Writing = 'Writing',
  Language = 'Language',
}

export enum EvaluationResultId {
  OpportunitiesToImprove = 'OPPORTUNITIES_TO_IMPROVE',
  OnTrack = 'ON_TRACK',
  Excelling = 'EXCELLING',
}

export enum DiagnosticReportType {
  Strengths = 'STRENGTHS',
  Improvements = 'IMPROVEMENTS',
}

export enum DisciplineTopics {
  ListeningAndSpeaking = 'Listening & Speaking',
  ReadingAndUnderstanding = 'Reading & Understanding',
  Writing = 'Writing',
  Language = 'Language',
}

export enum EvaluationResultNames {
  OPPORTUNITIES_TO_IMPROVE = 'Area for improvement',
  ON_TRACK = 'On track',
  EXCELLING = 'Excelling',
}
